import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/options-flow/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/economic-terminal' });
  },
});
